import { render, staticRenderFns } from "./DMModal.vue?vue&type=template&id=ec7c64c6"
import script from "./DMModal.vue?vue&type=script&lang=js"
export * from "./DMModal.vue?vue&type=script&lang=js"
import style0 from "./DMModal.vue?vue&type=style&index=0&id=ec7c64c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports